import React from 'react';

import PropTypes from 'prop-types';

import { Flex } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';

const EntityPickerModalLoadMoreButton = ({ onLoadMore }) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  return (
    <Flex alignItems="center" height="68px" paddingLeft="50px">
      <LinkButton onClick={onLoadMore}>{T.translate('LOAD_MORE')}</LinkButton>
    </Flex>
  );
};

EntityPickerModalLoadMoreButton.propTypes = {
  /**
   * Handler for load more button click.
   */
  onLoadMore: PropTypes.func.isRequired,
};

export default EntityPickerModalLoadMoreButton;
